import type { HashMap } from "@certa/types/src/common";
import { FieldTagSelectorCustomInputRegEx } from "../constants/fieldTagSelector.constants";

export const emailJoin = (
  payload: Record<string, any> = {},
  keyValues: string[],
  forDeployment?: boolean
) => {
  const values: HashMap = {
    to_emails: [],
    cc_emails: [],
    bcc_emails: []
  };

  keyValues.map(key => {
    // Static email join
    if (payload[`${key}_static`]) {
      if (payload[`${key}_static`]?.includes(",")) {
        values[key] = [
          ...payload[`${key}_static`]
            .split(",")
            .map((email: string) => (forDeployment ? `${email}` : `"${email}"`))
        ];
      } else {
        values[key].push(
          forDeployment
            ? `${payload[`${key}_static`]}`
            : `"${payload[`${key}_static`]}"`
        );
      }
    }

    // Dynamic email join
    if (payload[`${key}_dynamic`]) {
      values[key] = [
        ...values[key],
        ...payload[`${key}_dynamic`].map((val: string) =>
          forDeployment ? `{{${val}}}` : val
        )
      ];
    }

    return null;
  });

  return values;
};

export const emailSplit = (
  values: string[] = [],
  key: string,
  forImport?: boolean
) => {
  const filteredValues: HashMap = {
    [`${key}_emails_static`]: [],
    [`${key}_emails_dynamic`]: []
  };

  values.forEach(value => {
    if (forImport) {
      const ForImportFieldInputRegEx = /^{{(.*)}}$/;
      if (ForImportFieldInputRegEx.test(value)) {
        filteredValues[`${key}_emails_dynamic`].push(
          value.replace(ForImportFieldInputRegEx, "$1")
        );
      } else {
        filteredValues[`${key}_emails_static`].push(value);
      }
    } else {
      if (FieldTagSelectorCustomInputRegEx.test(value)) {
        filteredValues[`${key}_emails_static`].push(
          value.replace(FieldTagSelectorCustomInputRegEx, "$1")
        );
      } else {
        filteredValues[`${key}_emails_dynamic`].push(value);
      }
    }
  });
  return { ...filteredValues };
};
